/* eslint-disable no-prototype-builtins */
import React, { useState, useEffect, useRef } from 'react'
import { useNavigate, useParams, useLocation } from 'react-router-dom'

import axios from 'axios'
import { Link } from 'react-router-dom'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import IconButton from '@mui/material/IconButton'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import Modal from '@mui/material/Modal'

import FeedbackProfileItem from './FeedbackProfileItem'

import { editProfileTabJSX } from '../../profile/edit/editProfileTabJSX'
import { viewHingeProfileTabJSX } from '../../profile/view/hinge/viewHingeProfileTabJSX'
import { viewBumbleProfileTabJSX } from '../../profile/view/bumble/viewBumbleProfileTabJSX'
import { viewTinderProfileTabJSX } from '../../profile/view/tinder/viewTinderProfileTabJSX'
import { selectMediaItemModalJSX } from '../../profile/edit/modals/selectMediaItemModalJSX'
import { selectPromptModalJSX } from '../../profile/edit/modals/selectPromptModalJSX'
import { selectAboutMeModalJSX } from '../../profile/edit/modals/selectAboutMeModalJSX'
import { selectHobbyModalJSX } from '../../profile/edit/modals/selectHobbyModalJSX'

import useWindowDimensions from '../../../helpers/windowDimensions'
import { getPayload, userIsAuthenticated, getTokenFromLocalStorage } from '../../../helpers/storage'
import { seoPageTags } from '../../../helpers/analytics'
import { standardSpinner } from '../../../helpers/spinners'
import { navbarHeight, dashboardNavbarHeight, footerHeight, positionChangeWidthSm, profPicDefaultURL, minimumBumbleAboutMe, minimumBumbleHobbies, minimumBumbleMedia, minimumBumblePrompts, minimumHingeAboutMe, minimumHingeHobbies, minimumHingeMedia, minimumHingePrompts, minimumTinderAboutMe, minimumTinderHobbies, minimumTinderMedia, minimumTinderPrompts, minimumOnboardingMedia, minimumOnboardingAboutMe, minimumOnboardingHobbies, minimumOnboardingPrompts } from '../../../helpers/variableDefaults'
import { makeTabIndex } from '../../../helpers/formatting'
import { standardButton, exitModalIconButton } from '../../../helpers/buttons'
import { profileIsCompleted } from '../../../helpers/commonMethods'
import { advisoryElementJSX } from '../../../helpers/commonJSX'

// Edit Profile Page
const EditProfile = (props) => {

  const { isDemo, user, setUser, datingProfile, setDatingProfile, previousDatingProfile, setPreviousDatingProfile, profileType } = props
    
  // Window Dimensions
  const { height, width } = useWindowDimensions()

  // Navigate
  const navigate = useNavigate()

  // Params
  // const { userId, datingProfileId } = useParams()

  // Payload
  const payload = getPayload()

  // Refs
  const mediaItemsModalRef = useRef() // for scrolling to top after selecting a media item

  // Dashboard Navigation
  // const [user, setUser] = useState({ ...propsUser })
  // const [datingProfile, setDatingProfile] = useState({})
  // const [previousDatingProfile, setPreviousDatingProfile] = useState({ ...datingProfile })

  const [viewTinderImageIndex, setViewTinderImageIndex] = useState(0)

  // Viewing States
  const [showSubcaption, setShowSubcaption] = useState({
    mediaItem1: false,
    mediaItem2: false,
    mediaItem3: false,
    mediaItem4: false,
    mediaItem5: false,
    mediaItem6: false,
    mediaItem7: false,
    mediaItem8: false,
    mediaItem9: false,
  })
  const [mediaIsLoading, setMediaIsLoading] = useState({
    mediaItem1: false,
    mediaItem2: false,
    mediaItem3: false,
    mediaItem4: false,
    mediaItem5: false,
    mediaItem6: false,
    mediaItem7: false,
    mediaItem8: false,
    mediaItem9: false,
  })

  // Editing Elements
  const [selectedMediaItemIndex, setSelectedMediaItemIndex] = useState(-1)
  const [selectedPromptIndex, setSelectedPromptIndex] = useState(-1)
  const [selectedHobbyIndex, setSelectedHobbyIndex] = useState(-1)
  const [customCaptionSelected, setCustomCaptionSelected] = useState(false)
  const [customSubcaptionSelected, setCustomSubcaptionSelected] = useState(false)
  const [customPromptSelected, setCustomPromptSelected] = useState(false)
  const [customAboutMeSelected, setCustomAboutMeSelected] = useState(false)
  const [customHobbySelected, setCustomHobbySelected] = useState(false)
  
  const [newAboutMe, setNewAboutMe] = useState('')
  const [newMediaItem, setNewMediaItem] = useState({})
  const [newPrompt, setNewPrompt] = useState({})
  const [newHobby, setNewHobby] = useState('')

  // Modals
  const [openMediaItemSelectModal, setOpenMediaItemSelectModal] = useState(false)
  const [openPromptSelectModal, setOpenPromptSelectModal] = useState(false)
  const [openHobbySelectModal, setOpenHobbySelectModal] = useState(false)
  const [openAboutMeSelectModal, setOpenAboutMeSelectModal] = useState(false)
  const [openFeedbackInfo, setOpenFeedbackInfo] = useState(false)
  const [reviewerProfileInfo, setReviewerProfileInfo] = useState({})
  const [selectedProfileReview, setSelectedProfileReview] = useState({})

  // Deleting Profile Reviews
  const [loadingDeleteProfileReview, setLoadingDeleteProfileReview] = useState(false)
  const [deletedProfileReviewIndex, setDeletedProfileReviewIndex] = useState(-1)

  // Vital Info
  const [bioObject, setBioObject] = useState({ ...user.bio })
  const [newVitalInfo, setNewVitalInfo] = useState({ ...user.bio.vitalInfo })
  const [loadingVitalInfo, setLoadingVitalInfo] = useState(false)

  //Keeps track of which tab we are in, default is Edit at index 0
  const [value, setValue] = useState(0)

  // Loading
  const [loading, setLoading] = useState({
    loading: false,
    mediaItems: false,
    aboutMe: false,
    prompts: false,
    hobbies: false,
    selectMediaItem: false,
    selectAboutMe: false,
    selectPrompt: false,
    selectHobby: false,
  })
  const [videoIsLoading, setVideoIsLoading] = useState(true)

  // Save Successful
  const [saveSuccessful, setSaveSuccessful] = useState({
    mediaItems: false,
    aboutMe: false,
    prompts: false,
    hobbies: false,
    vitalInfo: false,
    selectMediaItem: false,
    selectAboutMe: false,
    selectPrompt: false,
    selectHobby: false,
  })
  
  // Errors
  const [errors, setErrors] = useState({
    errors: false,
    mediaItems: false,
    aboutMe: false,
    prompts: false,
    hobbies: false,
    vitalInfo: false,
    selectMediaItem: false,
    selectAboutMe: false,
    selectPrompt: false,
    selectHobby: false,
  })

  const resetLoadingAndErrors = () => {
    setLoading({
      loading: false,
      mediaItems: false,
      aboutMe: false,
      prompts: false,
      hobbies: false,
      selectMediaItem: false,
      selectAboutMe: false,
      selectPrompt: false,
      selectHobby: false,
    })

    setErrors({
      errors: false,
      mediaItems: false,
      aboutMe: false,
      prompts: false,
      hobbies: false,
      selectMediaItem: false,
      selectAboutMe: false,
      selectPrompt: false,
      selectHobby: false,
    })
  }

  const resetSaveSuccessful = () => {
    setSaveSuccessful({
      mediaItems: false,
      aboutMe: false,
      prompts: false,
      hobbies: false,
      selectMediaItem: false,
      selectAboutMe: false,
      selectPrompt: false,
      selectHobby: false,
    })
  }

  const isLoading = () => {
    return Object.keys(loading).filter(loadingKey => loading[loadingKey] === true).length > 0
  }

  // useEffect(() => {
    
  //   const fetchData = async () => {
  //     // Empty for now
  //   }

  //   fetchData()

  // }, [])

  useEffect(() => {
    // console.log('value useEffect Runs')

  }, [value])

  useEffect(() => {
    console.log('newVitalInfo useEffect')

    const newBio = { ...datingProfile.bio, vitalInfo: { ...newVitalInfo } }
    const newDatingProfile = { ...datingProfile, bio: { ...newBio } }
    setDatingProfile({ ...newDatingProfile })
  }, [newVitalInfo])

  useEffect(() => {
    console.log('bioObject useEffect')
    if ('bio' in user) {

      // Vital Info
      const newUserBio = { ...user.bio, vitalInfo: { ...bioObject.vitalInfo } }

      // Add bio to newUser
      const newUser = { ...user, bio: { ...newUserBio } }

      // Update Dating Profiles
      if ('datingProfiles' in user) {
        const updatedDatingProfilesArray = []
        const newDatingProfilesArray = [ ...user.datingProfiles ]
        for (let i = 0; i < newDatingProfilesArray.length; i++) {
          
          // Vital Info
          const newDatingProfileBio = { ...newDatingProfilesArray[i].bio, vitalInfo: { ...bioObject.vitalInfo } }
          const newDatingProfile = { ...newDatingProfilesArray[i], bio: { ...newDatingProfileBio } }

          // Add updated profile
          updatedDatingProfilesArray.push({ ...newDatingProfile })
        }

        if (updatedDatingProfilesArray.length === user.datingProfiles.length) {
          newUser.datingProfiles = [ ...updatedDatingProfilesArray ]
        }
      }

      setUser({ ...newUser })
    }
  }, [bioObject])

  useEffect(() => {

  }, [datingProfile, saveSuccessful, errors, openAboutMeSelectModal, openHobbySelectModal, openMediaItemSelectModal, openPromptSelectModal, showSubcaption, openFeedbackInfo, loadingDeleteProfileReview, customCaptionSelected, customSubcaptionSelected, customPromptSelected, customAboutMeSelected, customHobbySelected])

  // Handles tab changes
  const handleTabChange = (event, newValue) => {
    setValue(newValue)
  }

  const allChangesAreSaved = () => {
    return (
      (
        Object.keys(datingProfile).length > 0
        && 'media' in datingProfile
        && datingProfile.media.length === previousDatingProfile.media.length
        && 
          datingProfile.media.filter((item, itemIndex) => ((itemIndex > previousDatingProfile.media.length) || !('mediaItemId' in item) || (item.mediaItemId !== previousDatingProfile.media[itemIndex].mediaItemId) || (item.caption !== previousDatingProfile.media[itemIndex].caption) || (item.subcaption !== previousDatingProfile.media[itemIndex].subcaption))).length === 0 
      )
      && 
      (
        // datingProfile.type === 'tinder'
        // ||
        (
          Object.keys(datingProfile).length > 0
          && 'bio' in datingProfile
          && 'prompts' in datingProfile.bio
          && datingProfile.bio.prompts.length === previousDatingProfile.bio.prompts.length
          && 
            datingProfile.bio.prompts.filter((item, itemIndex) => 
              (
                (itemIndex > previousDatingProfile.bio.prompts.length)
                || (item.prompt !== previousDatingProfile.bio.prompts[itemIndex].prompt) 
                || (item.response !== previousDatingProfile.bio.prompts[itemIndex].response)
              )
            ).length === 0 
        )
      )
      && 
      (
        // datingProfile.type === 'hinge'
        // ||
        (
          Object.keys(datingProfile).length > 0
          && 'bio' in datingProfile
          && 'aboutMe' in datingProfile.bio
          && 'aboutMe' in previousDatingProfile.bio
          && datingProfile.bio.aboutMe === previousDatingProfile.bio.aboutMe
        )
      )
      &&
      (
        // datingProfile.type === 'hinge'
        // || datingProfile.type === 'bumble'
        // ||
        (
          Object.keys(datingProfile).length > 0
          && 'bio' in datingProfile
          && 'hobbies' in datingProfile.bio
          && datingProfile.bio.hobbies.length === previousDatingProfile.bio.hobbies.length
          && 
            datingProfile.bio.hobbies.filter((item, itemIndex) => (itemIndex > previousDatingProfile.bio.hobbies.length || item !== previousDatingProfile.bio.hobbies[itemIndex])).length === 0 
        )
      )
    )
  }

  const minimumMediaIsReached = () => {
    return (
      datingProfile.type === 'hinge'
        ?
        (minimumHingeMedia === 0 || datingProfile.media.length >= minimumHingeMedia)
        :
        datingProfile.type === 'bumble'
          ?
          (minimumBumbleMedia === 0 || datingProfile.media.length >= minimumBumbleMedia)
          :
          minimumHingeMedia === 0 || datingProfile.type === 'tinder'
            ?
            (minimumTinderMedia === 0 || datingProfile.media.length >= minimumTinderMedia)
            :
            (minimumOnboardingMedia === 0 || datingProfile.media.length >= minimumOnboardingMedia)
    )
  }

  const minimumPromptsIsReached = () => {
    return (
      datingProfile.type === 'hinge'
        ?
        (minimumHingePrompts === 0 || datingProfile.bio.prompts.length >= minimumHingePrompts)
        :
        datingProfile.type === 'bumble'
          ?
          (minimumBumblePrompts === 0 || datingProfile.bio.prompts.length >= minimumBumblePrompts)
          :
          datingProfile.type === 'tinder'
            ?
            (minimumTinderPrompts === 0 || datingProfile.bio.prompts.length >= minimumTinderPrompts)
            :
            (minimumOnboardingPrompts === 0 || datingProfile.bio.prompts.length >= minimumOnboardingPrompts)
    )
  }

  const minimumHobbiesIsReached = () => {
    return (
      datingProfile.type === 'hinge'
        ?
        (minimumHingeHobbies === 0 || datingProfile.bio.hobbies.length >= minimumHingeHobbies)
        :
        datingProfile.type === 'bumble'
          ?
          (minimumBumbleHobbies === 0 || datingProfile.bio.hobbies.length >= minimumBumbleHobbies)
          :
          datingProfile.type === 'tinder'
            ?
            (minimumTinderHobbies === 0 || datingProfile.bio.hobbies.length >= minimumTinderHobbies)
            :
            (minimumOnboardingHobbies === 0 || datingProfile.bio.hobbies.length >= minimumOnboardingHobbies)
    )
  }

  const minimumAboutMeIsReached = () => {
    return (
      datingProfile.type === 'hinge'
        ?
        (minimumHingeAboutMe === 0 || datingProfile.bio.aboutMe.length >= minimumHingeAboutMe)
        :
        datingProfile.type === 'bumble'
          ?
          (minimumBumbleAboutMe === 0 || datingProfile.bio.aboutMe.length >= minimumBumbleAboutMe)
          :
          datingProfile.type === 'tinder'
            ?
            (minimumTinderAboutMe === 0 || datingProfile.bio.aboutMe.length >= minimumTinderAboutMe)
            :
            (minimumOnboardingAboutMe === 0 || datingProfile.bio.aboutMe.length >= minimumOnboardingAboutMe)
    )
  }

  const getFeedbackIsEnabled = () => {
    return (
      profileIsCompleted(datingProfile) 
      && !(isLoading())
      && allChangesAreSaved()
    )
  }

  const handleGetFeedbackPressed = () => {
    // console.log('handleGetFeedbackPressed runs')

    if (!isDemo) {
      navigate(`/dating-profile/${datingProfile._id}/${user._id}/request-feedback`)
    } else {
      navigate(`/demo/${user.bio.vitalInfo.firstName.toLowerCase()}/${datingProfile.type}/request-feedback`)
    }
  }

  const feedbackInfoModalJSX = () => {

    const handleFeedbackInfoModalClose = () => {
      // console.log('handleFeedbackInfoModalClose runs ->')
      // console.log('open ->', open)
  
      setSelectedProfileReview({})
      setReviewerProfileInfo({})
      setOpenFeedbackInfo(false)
    }

    const handleViewReviewerProfilePressed = (e) => {
      e.preventDefault()
      console.log('handleViewReviewerProfilePressed runs')
  
      // Navigate to Reviewer Profile
      if (reviewerProfileInfo !== null && Object.keys(reviewerProfileInfo).length > 0 && '_id' in reviewerProfileInfo) {
        navigate(`/reviewer-profile/${reviewerProfileInfo._id}`)
      }
    }

    const feedbackDetailsElement = (element, value, reviewType) => {

      const nonFriendReviewDummyWidth = width < 350 ? 0 : width < 400 ? '5%' : width < 450 ? '15%' : width < 500 ? '20%' : width < 900 ? '25%' : width < 1200 ? '30%' : '35%'
      const friendReviewDummyWidth = width < 350 ? 0 : width < 400 ? '0%' : width < 450 ? '5%' : width < 500 ? '10%' : width < 900 ? '15%' : width < 1200 ? '20%' : '25%'

      return (
        <Box
          sx={{
            width: '100%',
            display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center',
          }}
        >
          <Box 
            sx={{
              width: reviewType === 'friend' ? friendReviewDummyWidth : nonFriendReviewDummyWidth,
            }}
          />
          <Box
            sx={{
              // backgroundColor: 'pink',
              mb: 0.5,
              // textWrap: 'nowrap',
              // width: width < positionChangeWidthSm ? '100%' : '75%', 
              // maxWidth: positionChangeWidthSm, 
              // maxWidth: width >= positionChangeWidthSm ? '325px' : '325px',
              // minWidth: '130px', 
              display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'flex-start',
              // flexWrap: 'nowrap',
            }}
          >
            <Typography
              sx={{
                color: 'black',
                fontSize: width < 500 ? '14px' : width < positionChangeWidthSm ? '16px' : '18px',
                fontWeight: 'bold',
                wrap: 'nowrap',
                whiteSpace: 'nowrap',
              }}
            >
              {element}:
            </Typography>
            <Typography
              sx={{
                ml: 2,
                color: element === 'Link' ? 'blue' : 'black',
                fontSize: width < 500 ? '14px' : width < positionChangeWidthSm ? '16px' : '18px',
                whiteSpace: 'nowrap',
              }}
            >
              {element !== 'Link' ? value : <a href={value} target={'_blank'} rel={'noopener noreferrer'}>Click Here</a>}
            </Typography>
          </Box>
        </Box>
      )
    }

    return (
      <Modal
        open={openFeedbackInfo}
        onClose={handleFeedbackInfoModalClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        keepMounted
        sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}
      >
        <Box 
          sx={{ 
            // position: 'absolute',
            // left: '50%',
            // top: '50%',
            // transform: 'translate(-50%, -50%)',
            // width: width < positionChangeWidthSm ? '85%' : '450px',
            width: '85%',
            height: '85%',
            bgcolor: 'white',
            border: '2px solid #000',
            boxShadow: 24,
            p: 4, 
            overflowY: 'scroll',
            '&::-webkit-scrollbar': {
              WebkitAppearance: 'none',
              width: '8px',
            },
            '&::-webkit-scrollbar-thumb': {
              borderRadius: '4px',
              backgroundColor: 'rgba(0, 0, 0, .35)',
              webkitBoxShadow: '0 0 1px rgba(255, 255, 255, .5)',
            },
            display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center',
          }}
        >
          {/* Exit Icon Button */}
          <Box
            sx={{
              position: width < positionChangeWidthSm ? 'inherit' : 'absolute',
              top: width < positionChangeWidthSm ? '0px' : '10%', left: width < positionChangeWidthSm ? '0px' : '37%',
              // mr: 0, mb: 1,
              width: '100%',
              display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center',
            }}
          >
            {exitModalIconButton(handleFeedbackInfoModalClose, false, 0, 1, 1)}
          </Box>

          {/* Reviewer Image */}
          {/* {console.log('profPicDefaultURL ->', profPicDefaultURL)}
          {console.log('reviewerProfileInfo.profilePicture ->', reviewerProfileInfo.profilePicture)} */}
          <Box 
            sx={{ 
              my: 1,
              width: width < positionChangeWidthSm ? '200px' : '200px',
              height: width < positionChangeWidthSm ? '200px' : '200px',
              backgroundImage: selectedProfileReview.isFriendReview ? `url(${profPicDefaultURL})` : `url(${reviewerProfileInfo.profilePicture})`,
              backgroundSize: 'cover',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center',
              boxShadow: 3, 
              borderRadius: '50%', 
              display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-end', 
            }}
          />

          {/* Name of Reviewer */}
          {feedbackDetailsElement('Name of Reviewer', selectedProfileReview.reviewerFirstName)}

          {/* Email of Friend Reviewer */}
          {selectedProfileReview.isFriendReview && feedbackDetailsElement('Email', selectedProfileReview.reviewerEmail)}

          {/* Link for Friend Review */}
          {selectedProfileReview.isFriendReview && feedbackDetailsElement('Link', `https://www.swipelytics.com/dating-profile/${selectedProfileReview.datingProfileId}/${selectedProfileReview._id}/friend-review`)}

          {/* Security Code for Friend Review */}
          {selectedProfileReview.isFriendReview && feedbackDetailsElement('Security Code', selectedProfileReview.securityCode)}

          {/* Review Type */}
          {feedbackDetailsElement('Review Type', selectedProfileReview.isFriendReview ? 'Friend' : selectedProfileReview.isAIReview ? 'AI' : 'Expert')}

          {/* Date */}
          {feedbackDetailsElement('Date of Request', (new Date(selectedProfileReview.createdAt)).toLocaleDateString('en-us', { year: 'numeric', month: width < positionChangeWidthSm ? 'short' : 'long', day: 'numeric' }))}

          {/* View Profile Button */}
          {!selectedProfileReview.isFriendReview && standardButton(
            'View Reviewer Profile', 
            'button',
            'contained',
            false,
            'primary', 
            4,
            0,
            0,
            '220px', 
            '45px', 
            handleViewReviewerProfilePressed
          )}


        </Box>
      </Modal>
    )
  }

  const getFeedbackButtonJSX = () => {
    return (
      <>
        {standardButton(
          'Get Feedback', 
          'button',
          'contained',
          !getFeedbackIsEnabled(),
          'primary', 
          width >= positionChangeWidthSm ? 0 : 0,
          // 0,
          1,
          0,
          width > 300 ? '220px' : '95%', 
          '45px', 
          handleGetFeedbackPressed
        )}

        {/* Advisories */}
        <Box
          sx={{
            width: width > 300 ? '220px' : '95%',
            display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'flex-start',
          }}
        >
          {/* All Changes are Saved */}
          {
            !allChangesAreSaved() &&
            (minimumMediaIsReached() && minimumPromptsIsReached() && minimumAboutMeIsReached() && minimumHobbiesIsReached())
            &&
            advisoryElementJSX(
              `Must Save Changes`,
              allChangesAreSaved()
            )
          }

          {/* Minimum Photos */}
          {
            !minimumMediaIsReached() 
            &&
            (
              (datingProfile.type === 'hinge' && minimumHingeMedia > 0) 
              || (datingProfile.type === 'bumble' && minimumBumbleMedia > 0) 
              || (datingProfile.type === 'tinder' && minimumTinderMedia > 0)
            ) 
            &&
            advisoryElementJSX(
              `At least ${datingProfile.type === 'hinge' ? minimumHingeMedia : datingProfile.type === 'bumble' ? minimumBumbleMedia : datingProfile.type === 'tinder' ? minimumTinderMedia : minimumOnboardingMedia} photos`,
              minimumMediaIsReached()
            )
          }

          {/* Minimum Prompts */}
          {
            !minimumPromptsIsReached() 
            && 
            (
              (datingProfile.type === 'hinge' && minimumHingePrompts > 0) 
              || (datingProfile.type === 'bumble' && minimumBumblePrompts > 0) 
              || (datingProfile.type === 'tinder' && minimumTinderPrompts > 0)
            ) 
            && 
            advisoryElementJSX(
              `At least ${datingProfile.type === 'hinge' ? minimumHingePrompts : datingProfile.type === 'bumble' ? minimumBumblePrompts : datingProfile.type === 'tinder' ? minimumTinderPrompts : minimumOnboardingPrompts} prompts`,
              minimumPromptsIsReached()
            )
          }

          {/* Minimum About Me */}
          {
            !minimumAboutMeIsReached() 
            && 
            (
              (datingProfile.type === 'hinge' && minimumHingeAboutMe > 0) 
              || (datingProfile.type === 'bumble' && minimumBumbleAboutMe > 0) 
              || (datingProfile.type === 'tinder' && minimumTinderAboutMe > 0)
            ) 
            &&
            advisoryElementJSX(
              `At least ${datingProfile.type === 'hinge' ? minimumHingeAboutMe : datingProfile.type === 'bumble' ? minimumBumbleAboutMe : datingProfile.type === 'tinder' ? minimumTinderAboutMe : minimumOnboardingAboutMe} about me`,
              minimumAboutMeIsReached()
            )
          }

          {/* Minimum Hobbies */}
          {
            !minimumHobbiesIsReached() 
            && 
            (
              (datingProfile.type === 'hinge' && minimumHingeHobbies > 0) 
              || (datingProfile.type === 'bumble' && minimumBumbleHobbies > 0) 
              || (datingProfile.type === 'tinder' && minimumTinderHobbies > 0)
            ) 
            &&
            advisoryElementJSX(
              `At least ${datingProfile.type === 'hinge' ? minimumHingeHobbies : datingProfile.type === 'bumble' ? minimumBumbleHobbies : datingProfile.type === 'tinder' ? minimumTinderHobbies : minimumOnboardingHobbies} hobbies`,
              minimumHobbiesIsReached()
            )
          }
        </Box>

      </>
    )
  }

  return (
    <>
      {/* Helmet — for analytics, seo, and page title changing */}
      {/* {seoPageTags(
        'Edit Profile'
      )} */}

      {/* Body */}
      {loading.loading ?
        <Box sx={{ 
          width: '100%',
          // minHeight: `calc(100vh - ${navbarHeight} - ${footerHeight} - ${dashboardNavbarHeight})`,
          minHeight: `calc(100vh - ${navbarHeight} - ${footerHeight})`,
          mt: 0, mb: 0,
          display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', 
        }}>
          {standardSpinner()}
        </Box>
        : 
        <Box 
          sx={{ 
            mb: 4,
            width: '100%',
            minHeight: `calc(100vh - ${navbarHeight} - ${footerHeight})`,
            display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center', 
          }}
        >

          {/* Tabs */}
          <Box 
            sx={{ 
              mt: 1, 
              width: '100%',
              display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center',
            }}
          >
            <Tabs
              value={value}
              onChange={handleTabChange}
              textColor="primary"
              indicatorColor="primary"
              aria-label="primary tabs example"
              variant={'standard'}
              sx={{ 
                // backgroundColor: 'yellow',
                // width: '90vw', maxWidth: '375px',
                // width: width < superSmallScoreboardWidth ? '100%' : '275px',
                borderBottom: 1, borderColor: 'divider',
                // display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center',
              }}
            >
              {['Edit', 'View', 'Feedback'].map((tabName, tabIndex) => (
                <Tab key={tabIndex} label={tabName} {...makeTabIndex(tabIndex)} />
              ))}
            </Tabs>
          </Box>


          {/* Get Feedback Button */}
          {value !== 1 
            &&
            <Box
              sx={{
                // ml: width >= positionChangeWidthSm ? `calc(150px + 50px)` : '0px',
                mt: 3, 
                // mb: 2,
                py: 2,
                backgroundColor: width >= positionChangeWidthSm ? 'whitesmoke' : 'whitesmoke',
                boxShadow: width >= positionChangeWidthSm ? 3 : 3,
                borderRadius: (width >= positionChangeWidthSm || value === 2) ? 3 : 0,
                width: (width >= positionChangeWidthSm || value === 2) ? '81vw' : '100%', maxWidth: value === 1 ? positionChangeWidthSm : value === 2 ? `calc(${positionChangeWidthSm}px * .9)` : `calc(${positionChangeWidthSm}px * .9)`, 
                // width: '90vw', maxWidth: value === 0 ? `540px` : '400px', 
                display: 'flex', flexDirection: 'column', justifyContent: width < positionChangeWidthSm ? 'center' : 'center', alignItems: 'center',
              }}
            >
              {getFeedbackButtonJSX()}
            </Box>
          }


          {/* Tab Panels */}

          {/* Edit Tabs */}
          {'type' in datingProfile && datingProfile.type.length > 0 && 
            editProfileTabJSX(
              isDemo,
              value, 0, 
              user, setUser,
              datingProfile, setDatingProfile,
              previousDatingProfile, setPreviousDatingProfile,
              selectedMediaItemIndex, setSelectedMediaItemIndex, 
              newMediaItem, setNewMediaItem,
              openMediaItemSelectModal, setOpenMediaItemSelectModal,
              customCaptionSelected, setCustomCaptionSelected, customSubcaptionSelected, setCustomSubcaptionSelected,
              selectedPromptIndex, setSelectedPromptIndex, 
              newPrompt, setNewPrompt,
              openPromptSelectModal, setOpenPromptSelectModal,
              customPromptSelected, setCustomPromptSelected,
              selectedHobbyIndex, setSelectedHobbyIndex, 
              newHobby, setNewHobby,
              openHobbySelectModal, setOpenHobbySelectModal,
              customHobbySelected, setCustomHobbySelected,
              newAboutMe, setNewAboutMe,
              openAboutMeSelectModal, setOpenAboutMeSelectModal,
              customAboutMeSelected, setCustomAboutMeSelected,
              bioObject, setBioObject,
              newVitalInfo, setNewVitalInfo,
              loadingVitalInfo, setLoadingVitalInfo,
              loading, setLoading,
              saveSuccessful, setSaveSuccessful,
              errors, setErrors,
              resetLoadingAndErrors, resetSaveSuccessful,
              width
            )
          }


          {/* View Tabs */}
          {/* Hinge */}
          {'type' in datingProfile && datingProfile.type === 'hinge' && 
            viewHingeProfileTabJSX(value, 1, false, false, datingProfile, user, showSubcaption, setShowSubcaption, mediaIsLoading, setMediaIsLoading, loading, setLoading, errors, setErrors, width, setDatingProfile)
          }

          {/* Bumble */}
          {'type' in datingProfile && datingProfile.type === 'bumble' && 
            viewBumbleProfileTabJSX(value, 1, false, false, datingProfile, user, showSubcaption, setShowSubcaption, mediaIsLoading, setMediaIsLoading, loading, setLoading, errors, setErrors, width, setDatingProfile)
          }

          {/* Tinder */}
          {'type' in datingProfile && datingProfile.type === 'tinder' && 
            viewTinderProfileTabJSX(value, 1, false, false, datingProfile, user, viewTinderImageIndex, setViewTinderImageIndex, showSubcaption, setShowSubcaption, mediaIsLoading, setMediaIsLoading, loading, setLoading, errors, setErrors, width, setDatingProfile)
          }

          {/* Feedback Tab */}
          {value === 2 &&
            <>
              {
                !(
                  (Object.keys(datingProfile).length <= 0) 
                  || !('profileReviews' in datingProfile) 
                  || (datingProfile.profileReviews === null) 
                  || (datingProfile.profileReviews.length === 0)
                )
                &&
                datingProfile.profileReviews.sort((a, b) => Date.parse(b.createdAt) - Date.parse(a.createdAt)).map((profileReview, profileReviewIndex) => (
                  
                  <Box 
                    key={profileReviewIndex}
                    sx={{
                      mt: profileReviewIndex === 0 ? 1 : 0,
                      width: '81vw', 
                      maxWidth: `calc(${positionChangeWidthSm}px * 0.9)`, 
                      mb: 0,
                      display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center',
                    }}
                  >
                    {/* Feedback Profile Item */}
                    {
                      <FeedbackProfileItem profileReview={profileReview} profileReviewIndex={profileReviewIndex} user={user} setUser={setUser} fromComponent={'profileHistory'} openFeedbackInfo={openFeedbackInfo} setOpenFeedbackInfo={setOpenFeedbackInfo} setReviewerProfileInfo={setReviewerProfileInfo} setSelectedProfileReview={setSelectedProfileReview} isDemo={isDemo} loadingDeleteProfileReview={loadingDeleteProfileReview} setLoadingDeleteProfileReview={setLoadingDeleteProfileReview} datingProfile={datingProfile} setDatingProfile={setDatingProfile} deletedProfileReviewIndex={deletedProfileReviewIndex} setDeletedProfileReviewIndex={setDeletedProfileReviewIndex} />
                    }
                  </Box>
                ))
              }
            </>
          }

          {/* Get Feedback Button */}
          {
            (
              value === 1 
            ) 
            &&
            <Box
              sx={{
                // ml: width >= positionChangeWidthSm ? `calc(150px + 50px)` : '0px',
                mt: value === 1 ? 0 : 2, mb: 4,
                py: 2,
                backgroundColor: 'whitesmoke',
                boxShadow: 3,
                borderRadius: width >= 400 ? 3 : 0,
                width: positionChangeWidthSm >= width ? '100%' : '100%', maxWidth: value === 1 ? '400px' : `calc(${positionChangeWidthSm}px * .9)`, 
                // width: '90vw', maxWidth: value === 0 ? `540px` : '400px', 
                display: 'flex', flexDirection: 'column', justifyContent: width < positionChangeWidthSm ? 'center' : 'center', alignItems: 'center',
              }}
            >
              {getFeedbackButtonJSX()}
            </Box>
          }


          {/* Modals */}
          {/* Media Item Modal */} 
          {openMediaItemSelectModal && selectedMediaItemIndex > -1 && Object.keys(newMediaItem).length > 0 &&
            selectMediaItemModalJSX(
              user, 
              datingProfile, setDatingProfile, 
              previousDatingProfile, setPreviousDatingProfile, 
              selectedMediaItemIndex, setSelectedMediaItemIndex, 
              newMediaItem, setNewMediaItem,
              openMediaItemSelectModal, setOpenMediaItemSelectModal,
              // videoThumbnail, videoDuration,
              videoIsLoading, setVideoIsLoading,
              customCaptionSelected, setCustomCaptionSelected, customSubcaptionSelected, setCustomSubcaptionSelected,
              loading, setLoading,
              errors, setErrors,
              saveSuccessful, setSaveSuccessful,
              width,
              mediaItemsModalRef,
              navigate
            )
          }

          {/* Prompt Modal */} 
          {openPromptSelectModal && selectedPromptIndex > -1 && Object.keys(newPrompt).length > 0 &&
            selectPromptModalJSX(
              user, 
              datingProfile, setDatingProfile, 
              previousDatingProfile, setPreviousDatingProfile, 
              selectedPromptIndex, setSelectedPromptIndex,
              newPrompt, setNewPrompt,
              openPromptSelectModal, setOpenPromptSelectModal,
              customPromptSelected, setCustomPromptSelected,
              loading, setLoading,
              errors, setErrors,
              saveSuccessful, setSaveSuccessful,
              width
            )
          }

          {/* About Me Modal */} 
          {openAboutMeSelectModal &&
            selectAboutMeModalJSX(
              user, 
              datingProfile, setDatingProfile, 
              previousDatingProfile, setPreviousDatingProfile, 
              newAboutMe, setNewAboutMe,
              openAboutMeSelectModal, setOpenAboutMeSelectModal,
              customAboutMeSelected, setCustomAboutMeSelected,
              loading, setLoading,
              errors, setErrors,
              saveSuccessful, setSaveSuccessful,
              width
            )
          }

          {/* Hobby Modal */} 
          {openHobbySelectModal && selectedHobbyIndex > -1 &&
            selectHobbyModalJSX(
              user, 
              datingProfile, setDatingProfile, 
              previousDatingProfile, setPreviousDatingProfile, 
              selectedHobbyIndex, setSelectedHobbyIndex,
              newHobby, setNewHobby,
              openHobbySelectModal, setOpenHobbySelectModal,
              customHobbySelected, setCustomHobbySelected,
              loading, setLoading,
              errors, setErrors,
              saveSuccessful, setSaveSuccessful,
              width
            )
          }

          {/* Feedback Info Modal */}
          {openFeedbackInfo && 
            (
              (reviewerProfileInfo !== null && Object.keys(reviewerProfileInfo).length > 0) 
              || 
              (selectedProfileReview !== null && Object.keys(selectedProfileReview).length > 0)
            ) &&
            feedbackInfoModalJSX()
          }

        </Box>
      }
    </>
  )

}

export default EditProfile
